import { getCurrentUrl } from "@/utils/app.js";

// const devApiUrl = 'http://47.93.160.16:9088'; //本地开发环境
const devApiUrl = "https://hsjapidev.hulian120.com"; //本地开发环境


// const devApiUrl = "http://47.93.160.16:9088"; //本地开发环境
// const buildDevApiUrl = 'http://192.168.48.192:9088';//打包开发环境
const buildDevApiUrl = "http://47.93.160.16:9088"; //打包开发环境
const buildDevTestApiUrl = "http://192.168.48.192:9288"; //打包开发测试环境
// const buildTestApiUrl = 'http://192.168.48.192:9188';//打包测试环境
const buildTestApiUrl = "http://47.93.160.16:9188"; //打包测试环境
const buildPreApiUrl = "https://hsjapidev.hulian120.com"; //打包预发布环境
const buildProApiUrl = "https://hsjapi.hulian120.com"; //打包正式环境

//主域名被封，判断当前域名是临时域名的话，授权也是用使用新域名
const isTempDomain = window.location.host.indexOf("hushijia120") > -1;
// 微信回调地址

const devWxUrl = isTempDomain
  ? "https://wxauth.hushijia120.com/"
  : "https://wxauth.hulian120.com/";
const proWxUrl = isTempDomain
  ? "https://wxauth.hushijia120.com/"
  : "https://wxauth.hulian120.com/";

let useApiUrl, wxUseUrl, h5Online, couponUrl;
// couponUrl 是优惠券相关的地址，另外一个内嵌H5
wxUseUrl = devWxUrl;
//护士加超级会员
let SVipUrl = "https://mw.hulian120.com/256";
let activeShareCourse = "https://mw.hulian120.com/249";
// 护理公开课超级会员购买页
const hlGkkSvipUrl = "https://opacts.hulian120.com/activity-course-share/hlGkkSvip.html";

if (process.env.NODE_ENV === "development") {
  useApiUrl = devApiUrl;
  // useApiUrl = buildProApiUrl;
  couponUrl = "https://mw.hulian120.com/192";
} else {
  //production
  switch (process.env.VUE_APP_MODE) {
    case "buildDev":
      useApiUrl = buildDevApiUrl;
      h5Online = "http://47.93.160.16:9088/webs/108/";
      couponUrl = "http://39.105.181.235:8088/webs/193";
      break;
    case "buildDevTest":
      useApiUrl = buildDevTestApiUrl;
      break;
    case "buildTest":
      useApiUrl = buildTestApiUrl;
      h5Online = "http://39.105.181.235:8088/webs/109/";
      couponUrl = "http://39.105.181.235:8088/webs/191";
      break;
    case "buildPre":
      useApiUrl = buildPreApiUrl;
      h5Online = "https://mw.hulian120.com/110/#/";
      couponUrl = "https://mw.hulian120.com/192";
      break;
    default:
      useApiUrl = buildProApiUrl;
      SVipUrl = "https://opacts.hulian120.com/slnewvip";
      activeShareCourse = "https://opacts.hulian120.com/activity-course-share";
      h5Online = "https://opacts.hulian120.com/online_qa/#/";
      couponUrl = "https://opacts.hulian120.com/appweb_extra";
      wxUseUrl = proWxUrl;
      break;
  }
}

let CurrentUrl = getCurrentUrl();

export default {
  sharePageUrl: CurrentUrl,
  apiUrl: useApiUrl,
  SVipUrl,
  activeShareCourse,
  hlGkkSvipUrl,
  apiPrefix: "",
  timeout: 18000,
  requestRetry: 4,
  requestRetryDelay: 800,
  designSize: 375, //设计稿宽度 375
  ossUrl: "https://jkhhtest.oss-cn-beijing.aliyuncs.com/", //附件前缀
  alarmCall: "110", // 报警电话
  wechatAppId: "wxec1e84ca9333d45c", // 微信AppId
  smallParams: "gh_72747bc1f1db", // 小程序原始id
  weChatRetURL: "https://dev50.hulian120.com", // 微信回调地址前缀
  wxUseUrl: wxUseUrl,
  shareLogo: "http://p.hulian120.com/share/app_share_icon.png", // 分享logo
  h5Online: h5Online, //h5的在线答疑
  couponUrl: couponUrl,
  isShowAngleVip: true, // 非天使vip模块是否显示天使vip相关的浮条
  tokenKey: "HSJ_ACCESS_TOKEN",
  userInfoKey: "HSJ_USER_INFO",
};
